<template>
  <li class="dropdown" id="notifications-dropdown">
    <a class="dropdown-toggle count-info" data-toggle="dropdown" href="#">
      <i class="fa fa-bell"></i>  <span class="label label-primary" v-if="count">{{ count }}</span>
    </a>
    <ul class="dropdown-menu dropdown-alerts">
      <li v-for="notification in notifications" v-bind:class="{ unread: notification.date.isAfter(readAt) }">
        <router-link :to="{ name: 'map', query: { driver: notification.id } }" title="">
          <span class="driver">{{ notification.name }}<span class="rego">{{ notification.registration }}</span></span>
          <span class="location">{{ notification.location }}</span>
          <span class="datetime">{{ notification.date.format('DD/MM/YYYY h:mmA') }}</span>
        </router-link>
      </li>
    </ul>
  </li>
</template>
<script>
  import { map, filter } from 'lodash'
  import moment from 'moment'
  import { http } from 'utils'
  import $ from 'jquery'

  export default {

    data () {
      return {
        privateChannel: 'notifications',
        notifications: [],
        readAt: {}
      }
    },

    created () {
      this.getNotifications()
      this.$echo.private(this.privateChannel).stopListening('NotificationsUpdated')

      this.$echo.private(this.privateChannel).listen('NotificationsUpdated', () => {
        this.getNotifications()
      })
    },

    mounted () {
      $(this.$el).on('show.bs.dropdown', this.handleOpened)
      $(this.$el).on('hide.bs.dropdown', this.handleClosed)
    },

    beforeDestroy () {
      $(this.$el).off('show.bs.dropdown', this.handleOpened)
      $(this.$el).off('hide.bs.dropdown', this.handleClosed)
      this.$echo.private(this.privateChannel).stopListening('NotificationsUpdated')
    },

    computed: {
      count () {
        let notifications = filter(this.notifications, notification => {
          return notification.date.isAfter(this.readAt)
        })
        return notifications.length
      }
    },

    methods: {
      getNotifications () {
        http.get('notifications').then(response => {
          this.readAt = moment(response.data.read_at, 'YYYY-MM-DD HH:mm:ss')
          this.notifications = map(response.data.notifications, (notification) => {
            notification.date = moment(notification.date, 'YYYY-MM-DD HH:mm:ss')
            return notification
          })
        })
      },

      handleOpened () {
        http.post('notifications/opened')
      },

      handleClosed () {
        this.getNotifications()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Notifications.vue?4f5340d8